import { environment } from '../../../../environments/environment';

export const IndexDBName = 'SALSurveyDB';
export const SignedInSentinel = 'survey-was-signed-in';
export const IS_PRODUCTION = environment.production;
